import { render, staticRenderFns } from "./editProject.vue?vue&type=template&id=da0d2a38&scoped=true"
import script from "./editProject.vue?vue&type=script&lang=js"
export * from "./editProject.vue?vue&type=script&lang=js"
import style0 from "./editProject.vue?vue&type=style&index=0&id=da0d2a38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0d2a38",
  null
  
)

export default component.exports